import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { populateXYaxisPrediction } from "utils/reportUtils";
import { ReportStrings } from "constants/constantStrings";
import { valueStrings } from "constants/constantStrings";

import PlotlyReport from "./PlotlyReport";

const Prediction = ({ report, data, intialLayout, isLoading, error, width, setError }) => {
  const [chartData, setChartData] = useState(null);
  const { tagsAsObj } = useSelector(state => state.tags);

  useEffect(() => {
    if (data && data.Data) {
      const traceData = [];
      const processData = data.Data.Data;
      const yAxisData = processData["Y-axis"];
      if (yAxisData && processData.Time?.length !== 0) {
        const tag = tagsAsObj[yAxisData["TagId"]];
        if (processData["X-axis"].Time && yAxisData.PastData && yAxisData.FutureData) {
          traceData.push(
            populateXYaxisPrediction(
              processData["X-axis"].Time,
              true,
              yAxisData.PastData,
              "solid",
              ReportStrings.trendingData + ` (${tag.TagName} - ${tag.Units})`
            )
          );
          traceData.push(populateXYaxisPrediction(processData["X-axis"].Time, false, yAxisData.FutureData, "dot", ReportStrings.predictData));
        }
        setChartData(traceData);
      } else {
        report.error = valueStrings.noData;
        setError(valueStrings.noData);
      }
    }
  }, [data]);

  return <PlotlyReport chartData={chartData} layout={intialLayout} isLoading={isLoading} error={error} report={report} width={width} />;
};

export default Prediction;
